import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40f01ac2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-card overflow-y-scroll mt-5" }
const _hoisted_2 = { class: "mb-2" }

import {ref, PropType} from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import {UserBlacklistReason} from "@/models/blacklisting/UserBlacklistHistorique";


export default /*#__PURE__*/_defineComponent({
  __name: 'BlacklistingTable',
  props: {
    data: {
        type: Array as PropType<UserBlacklistReason[]>,
        required: true,
    },
},
  emits: ["filter-comments-by-reason"],
  setup(__props, { emit }) {

const props = __props;


const filterCommentsByReason = (index: string) => {
    emit("filter-comments-by-reason", index);
};


const tableData = ref(props.data);
const nbBlacklist = ref(props.data.length);
const paginator = ref(false);
const rowsPerPage = ref(3);
// Column configuration
const columns = ref([
    { field: "date", header: "Date de traitement", width: 150 },
    { field: "reason", header: "Raison", width: 200 },
]);

let isResizing = ref(false);
let startX = ref(0);
let startWidth = ref(0);
let columnIndex = ref(0);

// Function to initialize resizing
const initResize = (e: MouseEvent, index: number) => {
    isResizing.value = true;
    startX.value = e.clientX;
    startWidth.value = columns.value[index].width;
    columnIndex.value = index;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
};

// Function to resize column
const resizeColumn = (e: MouseEvent) => {
    if (isResizing.value) {
        const newWidth = startWidth.value + (e.clientX - startX.value);
        columns.value[columnIndex.value].width = Math.max(newWidth, 50); // Prevent column from becoming too small
    }
};

// Function to stop resizing
const stopResize = () => {
    isResizing.value = false;
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);
};
if (nbBlacklist.value > 3) {
    paginator.value = true;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(nbBlacklist.value) + " blacklisting", 1),
    _createVNode(_unref(DataTable), {
      paginator: paginator.value,
      value: tableData.value,
      rows: rowsPerPage.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), { headerStyle: "width: 1rem" }),
        _createVNode(_unref(Column), {
          field: "date",
          header: "Date de traitement"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("span", null, _toDisplayString(slotProps.data.date), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "reason",
          header: "Raison"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("span", null, _toDisplayString(slotProps.data.reason), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "action",
          header: "Action"
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_unref(Button), {
              type: "button",
              icon: "pi pi-eye",
              onClick: ($event: any) => (filterCommentsByReason(slotProps.data.uuid)),
              size: "small",
              severity: slotProps.data.reason === 'Whitelist' ? 'success' : 'danger'
            }, null, 8, ["onClick", "severity"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["paginator", "value", "rows"])
  ]))
}
}

})